import _ from 'lodash';
import React from 'react';
import {
  // testStatuses,
  testStringStatuses
  // getTestResultTitle
} from 'helpers/RequestTestsHelper';

const FilterOptions = () => {
  return _.map(testStringStatuses, status => {
    // const title = getTestResultTitle(id).toLowerCase();
    return (
      <option value={status} key={status}>
        {status}
      </option>
    );
  });
};

export default FilterOptions;



// WEBPACK FOOTER //
// ./src/containers/request/TestRequestList/FilterOptions.js